import React from 'react';
import type { FC } from 'react';

import { DropdownItem } from '@atlaskit/dropdown-menu';

import type { DialogsStateContainer } from '@confluence/dialogs';

import { useLabelsDescriptionText } from './useLabelsDescriptionText';
import { EditLabelDialogLoader } from './EditLabelDialogLoader';
import type { EditLabelDialogComponentProps } from './EditLabelDialogComponent';

type EditLabelsDropdownItemProps = {
	contentId: string;
	spaceKey: string;
	dialogs: DialogsStateContainer;
};
export const EditLabelDropdownItem: FC<EditLabelsDropdownItemProps> = ({
	contentId,
	spaceKey,
	dialogs,
}) => {
	const buttonText = useLabelsDescriptionText({ contentId });

	const showEditLabelDialog = () => {
		const dialogProps: EditLabelDialogComponentProps = {
			contentId,
			spaceKey,
			source: 'fabricEditor',
		};
		dialogs.showModal(EditLabelDialogLoader, dialogProps);
	};

	return (
		<DropdownItem key="edit-labels" onClick={showEditLabelDialog}>
			{buttonText}
		</DropdownItem>
	);
};
